import { api } from '../../lib/api';
import type { Weighting } from '../rooms/api';

/**
 * The rules the front page describes.
 *
 * Fetched rather than written into the copy for the same reason the console's
 * queue legend is: a page that hardcodes "×3, five dollars, 80% to the host" is
 * wrong the day somebody changes one of them, and wrong in the most expensive
 * place on the site. See `ExplainAction`.
 */
export interface Explanation {
  weighting: Weighting;
  /** Platform defaults. A host can price their own room; these are the start. */
  boosts: { basic_cents: number; priority_cents: number };
  /**
   * The split, as the one stored number and the processing rate it applies
   * after. The platform's cut is the remainder — see `Payments`.
   */
  revenue: { host_share_bp: number; fee_basis_points: number; fee_fixed_cents: number };
  /**
   * Which optional capabilities are switched on here.
   *
   * Three of them, allowlisted server-side rather than the whole flag list —
   * that list is where unfinished work lives. Public copy gates on these, so a
   * stranger is never told about a studio they cannot open or a tip button that
   * is not there.
   */
  features: { studio: boolean; tips: boolean; boosts_paid: boolean };
}

export const platform = {
  explain: () => api.get<Explanation>('/explain'),
};
